import Card from '../Molecules/Card';
import React, { useState, Component } from 'react';
import { client } from '../../client';

      

class CardScroll extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    this.state = {
      cardData: []
    };
  }

  componentDidMount() {
    client.getEntries({
      content_type: "curationItem",
      order: '-fields.year'
    })
      .then((response) => {
        this.setState({
          cardData : response.items
          
        })  
    })
      // .then((data) => {
      //   console.log(this.state.cardData)
      //   getEntries({'metadata.tags.sys.id[all]': 'tagOne,tagTwo'}))
      
      //   })

    
    .catch(console.error)
  }



  render() {

    const {cx} = this.props;
    const cardCx = "w-27 margin-t-l three-col-card phone-w-250 " 

    return (<div className={`${cx} card-scroll phone-center`}>
        {/* <Card cx={cardCx} borderMediaCard="bb"/> */}

        {/* {this.state.cardData.map((singleCardData, index) => (
                <Card  cx={`${cardCx} 
                ${index%3 == 0 ? "bt br bb phone-bl" : ""}
                ${index%3 == 1 ? "ba" : ""}
                ${index%3 == 2 ? "bt bb bl phone-br" : ""}
 
                `} data={singleCardData} key={index} borderMediaCard="bb" chipLink="/filter/kuratering"/>
              )
              
              )} */}

      {this.state.cardData.map((singleCardData, index) => (
                      <Card  cx={`${cardCx} ba`} data={singleCardData} key={index} borderMediaCard="bb" chipLink="/filter/kuratering"/>
                    )
                    )}


              

        
      </div>

    
    );
  }
}

export default CardScroll;




